<template>
  <div
    ref="scrollMarker"
    class="scroll-marker"
    :style="{ '--scroll-y': scrollY + 'px' }"
  >
    <div class="bottom-circle" v-if="bottomCircle"></div>
  </div>
</template>

<script>
export default {
  name: "ScrollMarker",
  props: {
    bottomCircle: Boolean,
    scrollHeight: {
      default: -1,
    },
  },
  data() {
    return {
      scrollY: 0,
    };
  },
  methods: {
    onScroll() {
      var container = document.getElementById("page-container");
      let scrollHeight = container.scrollHeight;
      let scrollMarkerTop = this.$refs.scrollMarker.getBoundingClientRect().top;
      let height = this.$refs.scrollMarker.getBoundingClientRect().height;
      let scrollH = this.scrollHeight === -1 ? scrollHeight : this.scrollHeight;

      this.scrollY = (
        (container.scrollTop / (scrollH - container.clientHeight)) *
        height
      ).clamp(0, height);
      let currentY = scrollMarkerTop + this.scrollY;
      this.$emit("scrolled", currentY);
    },
  },
  mounted() {
    document
      .getElementById("page-container")
      .addEventListener("scroll", this.onScroll);
  },
  beforeDestroy() {
    if (document.getElementById("page-container")) {
      document
        .getElementById("page-container")
        .removeEventListener("scroll", this.onScroll);
    }
  },
};
</script>

<style lang="scss">
$scroll-y: var(--scroll-y);
.scroll-marker {
  width: 2px;
  background: #ededed;
  display: grid;
  &::after {
    background: $color-accent;
    position: absolute;
    width: 12px;
    height: 12px;
    content: "";
    left: -5px;
    border-radius: 50%;
  }
  .bottom-circle {
    background: $color-accent;
    position: absolute;
    width: 12px;
    height: 12px;
    content: "";
    left: -5px;
    bottom: 0;
    border-radius: 50%;
  }
  &::before {
    content: "";
    background: $color-accent;
    position: absolute;
    left: 0;
    right: 0;
    // transition: height 0.2s;
    height: $scroll-y;
    top: 0;
  }
}
</style>
